//USER
async function authRequest(url, body) {
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(body),
  });

  const contentType = response.headers.get('content-type');
  const payload = contentType && contentType.includes('application/json')
    ? await response.json()
    : null;

  if (!response.ok) {
    const err = new Error(payload?.error || 'Une erreur est survenue.');
    err.code = payload?.code;
    throw err;
  }

  return payload;
}

export function loginUser(credentials) {
  return authRequest('/auth/login', credentials);
}

export function signupUser(credentials) {
  return authRequest('/auth/signup', credentials);
}

export function verifySignup(token) {
  return authRequest('/auth/signup/verify', { token });
}

export function resendVerification(credentials) {
  return authRequest('/auth/resend-verification', credentials);
}

export function claimAccount(credentials) {
  return authRequest('/auth/claim-account', credentials);
}

export function verifyClaimAccount(token) {
  return authRequest('/auth/claim-account/verify', { token });
}

export function requestPasswordReset(credentials) {
  return authRequest('/auth/forgot-password', credentials);
}

export function resetPassword(credentials) {
  return authRequest('/auth/reset-password', credentials);
}

export function sendContactMessage(details) {
  return authRequest('/api/contact', details);
}

//Get user
export async function getUser() {
  const response = await fetch('/api/getuser', {
    credentials: 'include',
  });

  // If the response is not OK (e.g., 401 or 404), handle gracefully
  if (!response.ok) {
    // Optionally: throw an error or return null
    return null;
  }

  // If the response has no body or is not JSON, avoid parsing
  const contentType = response.headers.get('content-type');
  if (!contentType || !contentType.includes('application/json')) {
    return null;
  }

  // Now safe to parse
  return await response.json();
};


//TRANSACTION
//Get codes
export async function getCodes() {
  const response = await fetch('/api/codes')
  return response.json();
};

export async function getQuickAccessCodes() {
  const response = await fetch('/api/codes/quickaccess', {
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error('Impossible de charger les raccourcis.');
  }

  return response.json();
};

//Get modificateurs
export async function getModifs() {
  const response = await fetch('/api/modifs')
  return response.json();
};

//Insert transaction
export async function insertTransac(transaction) {

  const response = await fetch('/api/transactions/insert', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(transaction)
  });

  return response

}



//Get all transactions
export async function getTransac(from, to) {

  const response = await fetch('/api/transactions', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      datedebut: from,
      datefin: to
    })
  });

    // If the response is not OK (e.g., 401 or 404), handle gracefully
  if (!response.ok) {
    // Optionally: throw an error or return null
    return null;
  }

  // If the response has no body or is not JSON, avoid parsing
  const contentType = response.headers.get('content-type');
  if (!contentType || !contentType.includes('application/json')) {
    return null;
  }

  // Now safe to parse
  return await response.json();
}

//Delete transaction
export async function deleteTransac(transacid) {
  const response = await fetch('/api/transactions/delete', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(transacid)
  });

  return response;
}

//Get transaction group
export async function getTransacGroupby(from, to) {

  const response = await fetch('/api/transactionsgroup', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      datedebut: from,
      datefin: to
    })
  });

    // If the response is not OK (e.g., 401 or 404), handle gracefully
  if (!response.ok) {
    // Optionally: throw an error or return null
    return null;
  }

  // If the response has no body or is not JSON, avoid parsing
  const contentType = response.headers.get('content-type');
  if (!contentType || !contentType.includes('application/json')) {
    return null;
  }

  // Now safe to parse
  return await response.json();
}


//DASHBOARD
//Get all transactions
export async function getTransacWeek() {
  const response = await fetch('/api/transactions/getWeek');
  return response.json()
}

//Get transactionsMonth
export async function getTransacMonth() {
  const response = await fetch('/api/transactions/getMonth');
  return response.json()
}

export async function getTransacSouscat(yearSelect) {
  const response = await fetch('/api/transactions/getSousCat', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ year: yearSelect })
  });

  return response.json();
}

// Get years
export async function getYears() {
  const response = await fetch('/api/transactions/getYears');
  return response.json()
}



//HOME
//Get today's transactions
export async function getThisDay() {
  const response = await fetch('/api/transactions/getThisDay');
  return response.json()
}

//Get this week's transactions
export async function getThisWeek() {
  const response = await fetch('/api/transactions/getThisWeek');
  return response.json()
}

//Get this month's transactions
export async function getThisMonth() {
  const response = await fetch('/api/transactions/getThisMonth');
  return response.json()
}

export async function getThisYear() {
  const response = await fetch('/api/transactions/getThisYear');
  return response.json()
}

//Get average per day
export async function getAvgDay() {
  const response = await fetch('/api/transactions/getAvgDay');
  return response.json()
}

//Get average per week
export async function getAvgWeek() {
  const response = await fetch('/api/transactions/getAvgWeek');
  return response.json()
}

//Get average per month
export async function getAvgMonth() {
  const response = await fetch('/api/transactions/getAvgMonth');
  return response.json()
}

//Get average per year
export async function getAvgYear() {
  const response = await fetch('/api/transactions/getAvgYear');
  return response.json()
}


//Get cite de la santé table
export async function getCiteRev(yearSelect) {
  const response = await fetch('/api/transactions/getCiteRev', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ year: yearSelect })
  });

  return response.json();
}